import type { EnhancedMover } from "../types/index.ts";
import { ScoreBreakdownBar } from "./ScoreBreakdownBar.tsx";

interface MoversTableProps {
  title: string;
  movers: EnhancedMover[];
  variant: "gainers" | "losers";
  onClickProject?: (mover: EnhancedMover) => void;
}

function MoverRow({
  mover,
  index,
  variant,
  onClick,
}: {
  mover: EnhancedMover;
  index: number;
  variant: "gainers" | "losers";
  onClick?: () => void;
}) {
  const content = (
    <>
      <span className="td-mover-rank">{index + 1}</span>
      <div className="td-mover-info">
        <span className="td-mover-name">{mover.name || `@${mover.twitterHandle}`}</span>
        {mover.categoryName && (
          <span
            className="td-cat-badge"
            style={{
              backgroundColor: `${mover.categoryColor ?? "#6b7280"}20`,
              color: mover.categoryColor ?? "#6b7280",
            }}
          >
            {mover.categoryName}
          </span>
        )}
      </div>
      <span className="td-mover-score">{mover.currentScore.toFixed(0)}</span>
      <span className={`td-mover-delta ${variant === "gainers" ? "positive" : "negative"}`}>
        {variant === "gainers" ? "+" : ""}
        {mover.delta.toFixed(1)}
      </span>
      <span className="td-mover-pct">
        {mover.pctChange > 0 ? "+" : ""}
        {mover.pctChange.toFixed(1)}%
      </span>
      <div className="td-mover-breakdown">
        <ScoreBreakdownBar
          social={mover.socialPoints}
          backers={mover.backersPoints}
          pedigree={mover.pedigreePoints}
          momentum={mover.momentumPoints}
          dev={mover.devPoints}
          revenue={mover.revenuePoints}
        />
      </div>
    </>
  );

  if (onClick) {
    return (
      <button type="button" className="td-mover-row td-clickable" onClick={onClick}>
        {content}
      </button>
    );
  }

  return <div className="td-mover-row">{content}</div>;
}

export function MoversTable({ title, movers, variant, onClickProject }: MoversTableProps) {
  return (
    <div className="td-movers-panel">
      <div className="td-panel-header">
        <span className="td-panel-title">{title}</span>
        <span className="td-panel-count">{movers.length}</span>
      </div>
      {movers.length === 0 ? (
        <div className="td-empty">No data yet</div>
      ) : (
        <div className="td-movers-table">
          {movers.map((m, i) => (
            <MoverRow
              key={m.id}
              mover={m}
              index={i}
              variant={variant}
              onClick={onClickProject ? () => onClickProject(m) : undefined}
            />
          ))}
        </div>
      )}
    </div>
  );
}
